export enum ReportReconciliationExceptionReferenceType {
  US_CONSUMPTION_ENTRY_ID = 'US_CONSUMPTION_ENTRY_ID',
  ENTRY_NUMBER = 'ENTRY_NUMBER',
  DAILY_STATEMENT_NUMBER = 'DAILY_STATEMENT_NUMBER',
  PERIODIC_STATEMENT_NUMBER = 'PERIODIC_STATEMENT_NUMBER',
  INVOICE_NUMBER = 'INVOICE_NUMBER',
  CBMS_VALUE = 'CBMS_VALUE',
  REPORT_VALUE = 'REPORT_VALUE',
}
